export const LANGUAGES = ['cat', 'en', 'es'] as const
export type TypeLang = typeof LANGUAGES[number]

type NestedObj = {
  [Key: string]: JsonPossibleValues
}

export type JsonPossibleValues = string | number | boolean | NestedObj | (string | number | boolean)[]

// Get all the nested keys (and the nested will be prefixed with the parent by dot)
type Join<K, P> = K extends string | number ?
  P extends string | number ?
  `${K}${'' extends P ? '' : '.'}${P}`
  : never : never;


// Max object nested level using sequential representation for proper depth tracking
type Prev = [never, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, ...0[]]

export type Paths<T, D extends number = 10> = [D] extends [never] ? never : T extends object ?
  { [K in keyof T]-?: K extends string | number ?
    `${K}` | Join<K, Paths<T[K], Prev[D]>>
    : never
  }[keyof T] : ''


// Type 'Leaves' instead of 'Paths' to get just the final keys with strings
// type Leaves<T, D extends number = 10> = [D] extends [never] ? never : T extends object ?
//   { [K in keyof T]-?: Join<K, Leaves<T[K], Prev[D]>> }[keyof T] : '';




